import create from 'zustand';

interface VersionHistoryDrawerState {
  isOpen: boolean;
  vendorName: string;
  productName: string | null;
  vendorLogoUrl: string | null;
  openDrawer: (params: {
    vendorName: string;
    productName: string | null;
    vendorLogoUrl: string | null;
  }) => void;
  closeDrawer: () => void;
}

const useVersionHistoryDrawerStore = create<VersionHistoryDrawerState>((set) => ({
  isOpen: false,
  vendorName: '',
  productName: null,
  vendorLogoUrl: null,
  openDrawer: ({ vendorName, productName, vendorLogoUrl }) =>
    set({ isOpen: true, vendorName, productName, vendorLogoUrl }),
  closeDrawer: () =>
    set({ isOpen: false, vendorName: '', productName: null, vendorLogoUrl: null }),
}));

export default useVersionHistoryDrawerStore;
